<template>
    <div class="container">
        <div class="intro-page">
            <h1 class="mb-4">{{$t('intro.title')}}</h1>
            <vue-markdown>{{$t('intro.description')}}</vue-markdown>
            <app-button
                    class="py-4"
                    v-on:onClick="finish"
            >
                {{$t('misc.next')}}
            </app-button>
        </div>
    </div>
</template>

<script>
    import AppButton from '@/components/app-button';
    import Media from '@/components/media';
    import { getTeacherUrl } from '@/utils/UrlUtil';
    import * as MutationTypes from '@/store/mutation-types';
    import VueMarkdown from 'vue-markdown';

    export default {
        components: {
            AppButton,
            Media,
            VueMarkdown
        },
        mounted() {
            this.$store.commit(MutationTypes.SET_BREADCRUMB_TO, '/');
        },
        methods: {
            finish() {
                this.$router.push(getTeacherUrl('select-theme'));
            }
        }
    }
</script>
